import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionExpiryService {
  readonly visible = signal(false);
  readonly secondsRemaining = signal(0);
  readonly isRefreshing = signal(false);

  private countdownTimer: ReturnType<typeof setInterval> | null = null;

  open(secondsRemaining: number): void {
    this.stopCountdown();
    this.visible.set(true);
    this.secondsRemaining.set(Math.max(0, secondsRemaining));
    this.isRefreshing.set(false);

    this.countdownTimer = setInterval(() => {
      const next = this.secondsRemaining() - 1;
      if (next <= 0) {
        this.secondsRemaining.set(0);
        this.stopCountdown();
        return;
      }
      this.secondsRemaining.set(next);
    }, 1000);
  }

  close(): void {
    this.stopCountdown();
    this.visible.set(false);
    this.isRefreshing.set(false);
    this.secondsRemaining.set(0);
  }

  setRefreshing(value: boolean): void {
    this.isRefreshing.set(value);
  }

  private stopCountdown(): void {
    if (this.countdownTimer !== null) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }
}
